<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col
          class="pa-2 mb-4 sticky-md"
          cols="12"
          md="4"
          style="top: 12px"
        ></v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
             
            </v-tab-item>

            <v-tab-item>
              <component
                :is="cardTexts.theme"
                v-model="cardTexts.data"
                :components="specialInfo"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات محصول</p>
                </div>
                <div class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="cardTexts.data.visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام محصول شما"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-data-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام محصول"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <!-- <div class="d-flex row justify-start gap-0">
                <v-btn
                  :disabled="e6 > 1"
                  class="mb-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-clearDefaults`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="حذف اطلاعات پیشفرض"
                />
              </div> -->
              <list-expansion
                flat
                icon="pencil-ruler"
                single
                title="انتخاب طرح قالب"
              >
                <template v-slot:content>
                  <theme-selector2
                    v-model="theme"
                    :components="customTheme"
                    :frames="picFrames"
                  />
                </template>
              </list-expansion>
              <list-expansion
                v-model="cardTexts.data"
                :components="specialInfo"
                :data="cardTexts.data"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-model`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود"
            />
          </template>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus, debounce, RobotAxios } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize.vue";
import QrManagement from "../qrland/components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import NewProCard from "@/view/components/Product/newProCard";
import Features from "@/view/pages/product/features";
import singleProduct from "@/view/components/Product/ProductEditor";
import factoryInfo from "@/view/pages/product/factoryInfo";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import NewDesign from "@/view/pages/product/newDesign";

const VideoGallerySingle = () =>
  import("@/view/components/Gallery/VideoGallerySingle");

export default {
  name: "editProduct",
  props:{
    id:{type:String, default:''},
  },
  components: {
    NewDesign,
    ThemeSelector2,
    ProductTheme2,
    NewProCard,
    PrevBtn,
    NextBtn,
    factoryInfo,
    ListExpansion,
    VideoGallerySingle,
    singleProduct,
    QrManagement,
    QrCustomize,
    QrMaker,
    QrGenerator,
    Features,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "editProduct-Model",

      theme: "newDesign",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      shortId: null,
      picFrames: [
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      finish: true,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "factoryInfo",
          value: "",
          title: "اطلاعات مجموعه",
          subtitle: "",
          icon: "account-outline",
          secondName: "اطلاعات مجموعه",
        },
        {
          name: "singleProduct",
          value: "",
          title: "اطلاعات محصول",
          subtitle: "",
          icon: "information-outline",
          model: "singleProduct",
          secondName: "اطلاعات محصول",
        },
        {
          name: "Features",
          value: "",
          title: "افزودن ویژگی محصول",
          subtitle: "",
          icon: "information-outline",
          model: "Features",
          secondName: "ویژگی های محصول",
        },
        {
          name: "imageUploader",
          value: "",
          title: "افزودن تصویر",
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
          secondName: "گالری عکس",
        },
        {
          name: "VideoGallerySingle",
          value: "",
          title: "گالری ویدئو",
          model: "VideoGallerySingle",
          subtitle: "",
          icon: "video-outline",
          secondName: "گالری ویدئو",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          secondName: "شبکه های اجتماعی",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: null,
      // ساختار اولیه داده شد تا در رندر اولیه قالب با خطای undefined مواجه نشود
      cardTexts: {
        theme: "newDesign",
        data: {
          visitName: ""
        }
      },
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },
  watch: {
    "cardTexts.photo.gallery": {
      deep: true,
      handler(val) {
        this.$root.$emit("rerenderSwiper");
      },
    },
    qrDesign: {
      handler() {
        if (this.destinationUrl) {
          this.loading = true;
          try {
            debounce(() => {
              this.preview(this.destinationUrl);
            }, 3000);
          } catch (e) {
            this.loading = false;
          }
        }
      },
      deep: true,
    },
    eyeStyle() {
      this.markQr(false);
    },
    qrStyle() {
      this.markQr(false);
    },
    qrSize() {
      this.markQr(false);
    },
  },
  mounted() {
    // مقداردهی اولیه دیتای ثابت
    this.cardTexts.data.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };
    this.fetchData();
  },
  methods: {
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "productModel",
        qrType: "dynamic",
        title: this.cardTexts.data.visitName || "",
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.cardTexts.theme || this.theme,
          data: this.cardTexts.data,
        }),
        qr: {
          section: "#link",
          link: "qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "productModel",
          title: this.cardTexts.data.visitName || "",
        })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("کارت محصول شما با موفقیت ویرایش شد.");
          if (!!this.finish) {
            this.$router.replace({ name: "modelsList" });
          }
        })
        .catch(({ response }) => {
          this.errors = response?.data?.errors || {};
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;

      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          // دریافت امن اطلاعات برای جلوگیری از کرش کردن
          let rawData = data?.data?.qr || data?.data;
          if (!rawData) return;

          let parsedData =
            typeof rawData.data === "string"
              ? JSON.parse(rawData.data)
              : rawData.data;

          // بررسی و اصلاح ساختار تا خطا ندهد
          if (!parsedData.data) parsedData.data = {};
          if (!parsedData.theme) parsedData.theme = this.theme;

          this.cardTexts = parsedData;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(link) {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", {
          section: "#link",
          link: link,
          backcolor: !this.qrDesign.qrStyleColors?.backcolor
            ? "#ffffff"
            : this.qrDesign.qrStyleColors?.backcolor,
          gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
            ? "#8900d5"
            : this.qrDesign.qrStyleColors?.gradient_color,
          frontcolor: !this.qrDesign.qrStyleColors?.frontColor
            ? "#000000"
            : this.qrDesign.qrStyleColors?.frontColor,
          gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : "",
          pattern: this.qrDesign.qrStyleColors.pattern,
          marker_in: this.qrDesign.MarkerCenter.eyePattern,
          marker_in_color: this.qrDesign.MarkerCenter.main,
          markers_color: this.qrDesign.MarkerCenter.different_markers_color
            ? "on"
            : "",
          marker: this.qrDesign.QrMarkOut.markOutPattern,
          different_markers_color:
            this.qrDesign.QrMarkOut.different_markers_color ||
            this.qrDesign.MarkerCenter.different_markers_color
              ? "on"
              : "",
          marker_out_color: this.qrDesign.QrMarkOut.main,
          marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
          marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
          marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
          marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
          custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
            ? "on"
            : "",
          outer_frame: this.qrDesign.QrFrame.framePattern,
          framecolor: this.qrDesign.QrFrame.main,
          framelabel: this.qrDesign.QrFrame.text,
          optionlogo: this.qrDesign.LogoImg.logoImg,
          no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : "",
          "logo-size": this.qrDesign.LogoImg.logoSize,
          label_font: "AbrilFatface.svg",
          "label-text-size": "100",
          size: "248",
          level: "H",
        })
        .then((res) => {
          this.loading = false;
          this.imageMade = null;
          this.svgMade = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    qrUpdate(final = false) {
      this.loading = true;

      const data = new URLSearchParams();
      data.append("type", "singleProduct");
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");

      data.append("qr[section]", "#link");
      data.append(
        "qr[backcolor]",
        !this.qrDesign.qrStyleColors?.backcolor
          ? "#ffffff"
          : this.qrDesign.qrStyleColors?.backcolor,
      );
      data.append(
        "qr[gradient_color]",
        !this.qrDesign.qrStyleColors?.gradient_color
          ? "#000000"
          : this.qrDesign.qrStyleColors?.gradient_color,
      );
      data.append(
        "qr[frontcolor]",
        !this.qrDesign.qrStyleColors?.frontColor
          ? "#000000"
          : this.qrDesign.qrStyleColors?.frontColor,
      );
      data.append(
        "qr[gradient]",
        this.qrDesign.qrStyleColors?.gradient ? "on" : "",
      );
      data.append("qr[pattern]", this.qrDesign.qrStyleColors.pattern);
      data.append("qr[marker_in]", this.qrDesign.MarkerCenter.eyePattern);
      data.append("qr[marker_in_color]", this.qrDesign.MarkerCenter.main);
      data.append(
        "qr[markers_color]",
        this.qrDesign.MarkerCenter.different_markers_color ? "on" : "",
      );
      data.append("qr[marker]", this.qrDesign.QrMarkOut.markOutPattern);
      data.append(
        "qr[different_markers_color]",
        this.qrDesign.QrMarkOut.different_markers_color ||
          this.qrDesign.MarkerCenter.different_markers_color
          ? "on"
          : "",
      );
      data.append("qr[marker_out_color]", this.qrDesign.QrMarkOut.main);
      data.append(
        "qr[marker_top_right_outline]",
        this.qrDesign.QrMarkOut.topRight,
      );
      data.append(
        "qr[marker_top_right_center]",
        this.qrDesign.MarkerCenter.topRight,
      );
      data.append(
        "qr[marker_bottom_left_outline]",
        this.qrDesign.QrMarkOut.bottomLeft,
      );
      data.append(
        "qr[marker_bottom_left_center]",
        this.qrDesign.MarkerCenter.bottomLeft,
      );
      data.append(
        "qr[custom_frame_color]",
        this.qrDesign.QrFrame?.different_markers_color ? "on" : "",
      );
      data.append("qr[outer_frame]", this.qrDesign.QrFrame.framePattern);
      data.append("qr[framecolor]", this.qrDesign.QrFrame.main);
      data.append("qr[framelabel]", this.qrDesign.QrFrame.text);
      data.append("qr[optionlogo]", this.qrDesign.LogoImg.logoImg);
      data.append("qr[no_logo_bg]", this.qrDesign.LogoImg.noBg ? "on" : "");
      data.append("qr[label_font]", "AbrilFatface.svg");
      data.append("qr[size]", "248");
      data.append("qr[level]", "H");
      data.append('qr["logo-size"]', this.qrDesign.LogoImg.logoSize);
      data.append('qr["label-text-size"]', "100");

      this.$api
        .put("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          this.finish = final;
          this.$toast.success("کیوآر محصول شما باموفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.data.visitName = "";
      this.cardTexts.data.isGradient = false;
      this.cardTexts.data.organizationName = "";
      this.cardTexts.data.subOrgan = "";
      this.cardTexts.data.userName = "";
      this.cardTexts.data.workField = "";
      this.cardTexts.data.phoneNumber = [{ number: "" }];
      this.cardTexts.data.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];
      this.cardTexts.data.Features = {
        show: "accordion",
        details: [
          {
            name: "",
            showIt: false,
            value: [],
          },
        ],
      };
      this.cardTexts.data.companyNumber = "";
      this.cardTexts.data.email = "";
      this.cardTexts.data.fax = "";
      this.cardTexts.data.location = "";
      this.cardTexts.data.city = "";
      this.cardTexts.data.singleProduct = {
        title: "",
        content: "",
        price: null,
        discount: "",
        payLink: "",
        details: [
          {
            label: "",
            value: "",
            icon: "",
            name: "",
            link: "",
          },
        ],
        image: undefined,
        color: undefined,
        icon: undefined,
        arm: [],
      };
      this.cardTexts.data.photo = {
        gallery: null,
        headBackground: "",
        profile: "",
        transition: "scale",
        hasWelcome: false,
        hasGif: false,
        hasGame: false,

        previewerQr: {
          previewer: {
            gif: "",
            game: {},
            transition: "scale",
          },
        },
      };
      this.cardTexts.data.codePostal = "";
      this.cardTexts.data.province = "";
      this.cardTexts.data.country = "";
      this.cardTexts.data.website = "";
      this.cardTexts.data.socialMedia = {};
      this.cardTexts.data.aboutUs = "";
      this.cardTexts.data.video_single = {
        name: "",
        videos: [],
      };
      this.cardTexts.data.center = [51.420296, 35.732379];
      this.cardTexts.data.coordinates = null;
      this.cardTexts.data.address = "";
      this.cardTexts.data.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
